// extracted by mini-css-extract-plugin
module.exports = {"hz-Listing-other-seller-list":"ListingOtherSellerList_hz-Listing-other-seller-list__OdSRZ"};